export class FocusTrapController {
    constructor(host, clickedOutsideCallback) {
        this.clickedOutsideCallback = clickedOutsideCallback;
        this._isActive = false;
        this._firstTabStop = null;
        this._lastTabStop = null;
        this._focusableElements = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        this._trapTabKey = (event) => {
            if (!this._isActive) {
                return;
            }
            const target = this.host.shadowRoot?.activeElement;
            if (event.key === "Tab") {
                if (target === this._lastTabStop && !event.shiftKey) {
                    event.preventDefault();
                }
                if (target === this._firstTabStop && event.shiftKey) {
                    event.preventDefault();
                }
            }
        };
        this._clickedOutside = (event) => {
            if (!this._isActive) {
                return;
            }
            const target = event.target;
            const hostContainsTarget = this.host.contains(target);
            const targetContainsHost = target.shadowRoot?.contains(this.host);
            const targetIsHost = target === this.host;
            if (!hostContainsTarget && !targetContainsHost && !targetIsHost) {
                this.clickedOutsideCallback();
            }
        };
        (this.host = host).addController(this);
    }
    hostDisconnected() {
        this.deactivate();
    }
    activate() {
        this._isActive = true;
        const focusableElements = [
            ...(this.host.shadowRoot?.querySelectorAll(this._focusableElements) || []),
        ];
        this._firstTabStop = focusableElements[0];
        this._lastTabStop = focusableElements[focusableElements.length - 1];
        document.addEventListener("keydown", this._trapTabKey);
        document.addEventListener("pointerdown", this._clickedOutside);
    }
    deactivate() {
        this._isActive = false;
        document.removeEventListener("keydown", this._trapTabKey);
    }
}
